<template>
  <div class="login">
    <el-card class="box-card" v-if="!createPwdShow">
      <div slot="header" class="clearfix">
        <span>
          <img src="@/assets/NuoWan.png" alt="" />
        </span>
      </div>
      <el-form label-width="80px" :model="form" ref="form" :rules="rules">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="form.password"></el-input>
        </el-form-item>
        <!-- 随机验证码 -->
        <el-form-item label="验证码" prop="verifyCode">
          <el-input
            v-model="form.verifyCode"
            ref="verifyCode"
            placeholder="验证码"
            class="identifyinput"
            style="width: 260px"
          ></el-input>
          <div class="identifybox" @click="refreshCode">
            <sidentify :identifyCode="identifyCode"></sidentify>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="authLogin('form')">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <router-view></router-view>
  </div>
</template>

<script>
  import {
    nameRule,
    passRule,
    verifyCodeRule,
    setIdentifyCode,
  } from "../utils/validate.js";
  import sidentify from "./Sidentify";
  export default {
    name: "Login",
    data() {
      return {
        form: {
          username: "",
          password: "",
          verifyCode: "",
        },
        rules: {
          username: [{ validator: nameRule, trigger: "blur" }],
          password: [{ validator: passRule, trigger: "blur" }],
          verifyCode: [
            { validator: verifyCodeRule, required: true, trigger: "blur" },
          ],
        },
        createPwdShow: false,
        identifyCodes: "1234567890", //验证码的数字库
        identifyCode: "", // 验证码组件传值
      };
    },
    components: { sidentify },
    mounted() {
      if (this.$route.path.includes("createPassword")) {
        this.createPwdShow = true;
      }
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
      setIdentifyCode(this.identifyCode);
    },
    methods: {
      //验证码----start
      randomNum(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
      },
      refreshCode() {
        this.identifyCode = "";
        this.makeCode(this.identifyCodes, 4);
      },
      makeCode(o, l) {
        for (let i = 0; i < l; i++) {
          this.identifyCode +=
            this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
        }
        // console.log("this.identifyCode:", this.identifyCode);
      },
      //验证码----end

      created() {
        this.refreshCode(); //初始化验证码
      },

      async authLogin(form) {
        // this.form.username = "tenant@thingsboard.org";
        // this.form.password = "tanant";
        setIdentifyCode(this.identifyCode);
        try {
          await this.$refs[form].validate(async (valid) => {
            if (valid) {
              await this.$store.dispatch("authLogin", {
                username: this.form.username,
                password: this.form.password,
                // username:"tenant@thingsboard.org",
                // password: "tenant"
              });
              this.$router.push("/home");
            } else {
              this.refreshCode();
            }
          });
        } catch (error) {
          alert(error.message);
        }
      },
    },
  };
</script>

<style lang="scss">
  .login {
    width: 100%;
    height: 100%;
    position: absolute;
    // background: #eee;
    .box-card {
      width: 500px;
      margin: 40px auto;
      background-color: #305680;
      border: 0;
      .el-form-item__label {
        color: #fff;
      }
      .el-form-item__content {
        height: 40px;
      }
      .el-button {
        width: 100%;
      }
      img {
        width: 450px;
      }
      .identifyinput {
        position: absolute;
        left: 0;
      }
      .identifybox {
        display: inline-block;
        width: 120px;
        height: 40px;
      }
    }
  }
</style>
